import { apiProvider } from './utilities/Provider';
import i18n from 'i18next';
import { toaster } from '@/components/ui/toaster';
import { toApiRequest, toUpdateRequest } from './jobOfferMapper';
import { isOfferPreparing } from '@/utils/offerPreparation';

const notifyIfPreparing = (offer) => {
    if (isOfferPreparing(offer)) {
        toaster.create({ type: 'info', title: i18n.t('models:offerPreparation.started'), closable: true, duration: 10000 });
    }
    return offer;
};

const MOCK_MODELS = [
    {
        id: "1",
        title: "Specjalista rekrutacyjny",
        description: "Analizuje ogromne zbiory informacji, odkrywa ukryte wzorce i dostarcza raporty, które pomogą Ci podejmować trafne decyzje biznesowe.",
        status: true,
        avatarUrl: "https://placehold.co/80x80/22c55e/white?text=AI",
    },
    {
        id: "2",
        title: "Asystent HR",
        description: "Wspiera procesy kadrowe, odpowiada na pytania pracowników i zarządza dokumentacją HR.",
        status: false,
        avatarUrl: "https://placehold.co/80x80/f97316/white?text=AI",
    },
];

const MOCK_SCENARIOS = {
    "1": [
        { id: "s1", name: "Rekrutacja IT", editedAt: "2026-06-20", createdAt: "2026-05-01" },
        { id: "s2", name: "Rekrutacja sprzedaż", editedAt: "2026-06-15", createdAt: "2026-04-10" },
        { id: "s3", name: "Rekrutacja menedżerska", editedAt: "2026-06-10", createdAt: "2026-03-20" },
    ],
    "2": [
        { id: "s4", name: "Onboarding HR", editedAt: "2026-06-18", createdAt: "2026-05-15" },
        { id: "s5", name: "Ocena pracownicza", editedAt: "2026-06-01", createdAt: "2026-04-22" },
    ],
};

const MOCK_RECRUITMENTS = {
    "s1": [
        { id: "r1", position: "Senior Frontend Developer", status: "active", createdAt: "2026-06-10", conversations: 14 },
        { id: "r2", position: "DevOps Engineer", status: "ended", createdAt: "2026-05-22", conversations: 7 },
        { id: "r3", position: "Product Manager", status: "active", createdAt: "2026-06-18", conversations: 3 },
    ],
    "s2": [
        { id: "r4", position: "QA Engineer", status: "active", createdAt: "2026-06-01", conversations: 21 },
        { id: "r5", position: "Backend Developer (Node.js)", status: "ended", createdAt: "2026-04-15", conversations: 9 },
    ],
    "s3": [
        { id: "r6", position: "Engineering Manager", status: "active", createdAt: "2026-06-12", conversations: 6 },
    ],
    "s4": [
        { id: "r7", position: "Rekruter wewnętrzny", status: "active", createdAt: "2026-06-05", conversations: 5 },
        { id: "r8", position: "HR Business Partner", status: "ended", createdAt: "2026-05-10", conversations: 12 },
    ],
    "s5": [
        { id: "r9", position: "Specjalista ds. wynagrodzeń", status: "active", createdAt: "2026-06-08", conversations: 3 },
    ],
};

export const ModelService = {
    getAll: (page = 1, pageSize = 20) =>
        apiProvider.get(`/Agent?page=${page}&pageSize=${pageSize}`),
    getById: (id) => apiProvider.get(`/Agent/${id}`),
    getScenarios: (agentId) => Promise.resolve(MOCK_SCENARIOS[agentId] ?? []),
    getScenarioById: (scenarioId) => {
        const all = Object.values(MOCK_SCENARIOS).flat();
        return Promise.resolve(all.find((s) => s.id === scenarioId) ?? null);
    },
    getRecruitments: (scenarioId, page = 1, pageSize = 20) =>
        apiProvider.get(`/Workflow/scenario/${scenarioId}?page=${page}&pageSize=${pageSize}`),
    getActiveWorkflowsByOwner: (ownerId, page = 1, pageSize = 20) =>
        apiProvider.get(`/Workflow/owner/${ownerId}/active?page=${page}&pageSize=${pageSize}`),
    createRecruitment: (scenarioId, jobOffer) =>
        apiProvider.post('Workflow', toApiRequest(scenarioId, jobOffer)).then(notifyIfPreparing),
    getRecruitmentById: (recruitmentId) =>
        apiProvider.get(`/Workflow/${recruitmentId}`),
    getRecruitmentScoringModel: (recruitmentId) =>
        apiProvider.get(`/Workflow/${recruitmentId}/scoring-model`),
    getScenarioScoringModel: (scenarioId) =>
        apiProvider.get(`/Scenario/${scenarioId}/scoring-model`),
    updateRecruitment: (recruitmentId, jobOffer) =>
        apiProvider.put(`Workflow/${recruitmentId}`, toUpdateRequest(jobOffer)).then(notifyIfPreparing),
    getOfferPreparation: (recruitmentId) =>
        apiProvider.get(`/Workflow/${recruitmentId}/preparation`),
    saveDraft: (jobOffer) =>
        apiProvider.post('Workflow/draft', toUpdateRequest(jobOffer, { isDraft: true })),
    endRecruitment: (scenarioId, recruitmentId) => Promise.resolve({success: true}),
    changeWorkflowStatus: (recruitmentId, status) =>
        apiProvider.patch(`Workflow/${recruitmentId}/status`, { status }),
    toggleFavorite: (recruitmentId) =>
        apiProvider.patch(`Workflow/${recruitmentId}/favorite`, {}),
};
   